import modem from '../assets/modem-x4.webp';

const Modem = () => {
  return (
    <div>
      <img
        src={modem}
        className="modem absolute bottom-10 left-10 z-30 transform-gpu transition-all duration-700 ease-in-out will-change-transform"
        alt="Modem device"
        width="58px"
        height="58px"
        style={{ backfaceVisibility: 'hidden' }}
      />
    </div>
  );
};

export default Modem;
